/* Master */
const masterRoutes = [
  {
    name: "v_csm_mas_001",
    path: "/page/master/v_csm_mas_001/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_001.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20810",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_002",
    path: "/page/master/v_csm_mas_002/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_002.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20820",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_003",
    path: "/page/master/v_csm_mas_003/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_003.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20830",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_004",
    path: "/page/master/v_csm_mas_004/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_004.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20840",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_005",
    path: "/page/master/v_csm_mas_005/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_005.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20200",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_006",
    path: "/page/master/v_csm_mas_006/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_006.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20400",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_007",
    path: "/page/master/v_csm_mas_007/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_007.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "",
        checkUserRight: false,
      },
    },
  },
  {
    name: "v_csm_mas_008",
    path: "/page/master/v_csm_mas_008/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_008.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20850",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_008_delete",
    path: "/page/Master/v_csm_mas_008_delete/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_008_delete.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20860",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_009",
    path: "/page/master/v_csm_mas_009/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_009.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20100",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_010",
    path: "/page/master/v_csm_mas_010/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_010.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20600",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_011",
    path: "/page/Master/v_csm_mas_011/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_011.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "21010",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_012",
    path: "/page/Master/v_csm_mas_012/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_012.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "21020",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_013",
    path: "/page/Master/v_csm_mas_013/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_013.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "",
        checkUserRight: false,
      },
    },
  },
  {
    name: "v_csm_mas_014",
    path: "/page/Master/v_csm_mas_014/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_014.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "",
        checkUserRight: false,
      },
    },
  },
  {
    name: "v_csm_mas_015",
    path: "/page/Master/v_csm_mas_015/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_015.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20700",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_016",
    path: "/page/Master/v_csm_mas_016/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_016.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "",
        checkUserRight: false,
      },
    },
  },
  {
    name: "v_csm_mas_017",
    path: "/page/Master/v_csm_mas_017/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_017.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20500",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_018",
    path: "/page/Master/v_csm_mas_018/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_018.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "",
        checkUserRight: false,
      },
    },
  },
  {
    name: "v_csm_mas_019",
    path: "/page/Master/v_csm_mas_019/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_019.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20300",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_021",
    path: "/page/Master/v_csm_mas_021/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_021.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "40120",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_021_create",
    path: "/page/Master/v_csm_mas_021_create/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_021_create.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "40110",
        checkUserRight: true,
      },
    },
  },
  {
    name: "v_csm_mas_program",
    path: "/page/Master/v_csm_mas_program/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_program.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "",
        checkUserRight: false,
      },
    },
  },
  {
    name: "v_csm_mas_set_hide",
    path: "/page/Config/setup/v_csm_config_set_hide/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_set_hide.vue`),
    meta: {
      auth: true,
    },
  },
  /* Customer */
  {
    name: "v_csm_cus_001",
    path: "/page/Customer/v_csm_cus_001/",
    component: () => import(`../Components/Pages/Customer/v_csm_cus_001.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "20910",
        checkUserRight: true,
      },
    },
  },
    {
    name: "v_csm_mas_set_emp_team",
    path: "/page/Master/v_csm_mas_set_emp_team/",
    component: () => import(`../Components/Pages/Master/v_csm_mas_set_emp_team.vue`),
    meta: {
      auth: true,
      mangoMenu: {
        menu_name: "CSM_WEB",
        menu_id: "21022",
        checkUserRight: true,
      },
    },
  },
  
];

export default masterRoutes;
